import React from 'react';
import { LiveTranscriptionClient } from '../index-types';
export default React.createContext<LiveTranscriptionClient | null>(null);
